import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { detectRoleShell, isInsideRoleShell, shellAwarePath } from './roleShell';

/**
 * navigate() that rewrites legacy paths when inside Learner / Studio shells.
 */
export function useShellNavigate() {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback((to, options) => {
        if (typeof to === 'string') {
            navigate(shellAwarePath(to, location.pathname), options);
            return;
        }
        if (to && typeof to === 'object') {
            const next = { ...to };
            if (typeof next.pathname === 'string') {
                next.pathname = shellAwarePath(next.pathname, location.pathname);
            }
            navigate(next, options);
            return;
        }
        navigate(to, options);
    }, [navigate, location.pathname]);
}

export function useShellEmbed() {
    const location = useLocation();
    const shell = detectRoleShell(location.pathname);
    return {
        shell,
        embedded: isInsideRoleShell(location.pathname),
        path: (p) => shellAwarePath(p, location.pathname),
    };
}
